import { NameEntity } from './name.model';

type Ordered<T> = T & { order: number };
type Category = NameEntity & { id: number };

export type ProductImage = { url: string; path: string };
export type OrderedProductImage = Ordered<ProductImage>;
export type OrderedProductVideo = Ordered<{ url: string }>;

export interface ProductItem {
  isPreOrder?: boolean;
  preOrderAvailableOn?: string | null;
  id: number;
  name: NameEntity;
  thumbnail: ProductImage;
  sku: string[];
  stock: (number | null)[];
  regularPrice: number[];
  salePrice: (number | null)[];
  costPrice: number[];
  categories: string[];
  primaryCategory?: string;
  isFeatured: boolean;
  keepTop: boolean;
  createdAt: string;
  status: number;
  type: number;
  vendorName: string;
  approvalStatus: number;
  shareLink?: string;
  models: (string | null)[];
  brand?: { name: NameEntity };
  itemCode: (string | null)[];
  barcode: (string | null)[];
}

export interface RelatedProduct {
  id: number;
  name: NameEntity;
  thumbnail?: ProductImage;
}

export interface RelatedProductItem {
  id: number;
  name: NameEntity;
  thumbnail: ProductImage;
}

export type ProductAttributeDetail = ProductAttribute & {
  attributeName: NameEntity;
  term: NameEntity;
};

export interface ProductAttribute {
  attributeId: number;
  termId: number;
}

export type VariantUpdate = Omit<VariantEntity, 'image' | 'attributes' | 'id'> & {
  id?: number;
  image?: string;
  attributes?: ProductAttribute[];
};

export interface VariantEntity {
  id: number;
  image: ProductImage | null;
  attributes: ProductAttributeDetail[];
  regularPrice: number;
  salePrice: number | null;
  discountExpiresAtUtc?: string | null;
  costPrice: number;
  sku: string;
  itemCode?: string;
  weight: number;
  isManageableStock: boolean;
  height: number;
  length: number;
  width: number;
  status: number;
  stock: number;
  barcode: string;
  model?: string;
  isBundleComponentPriceVariant?: boolean;
}

export enum BundleStockMode {
  Manual = 0,
  ComponentDerived = 1,
}

export interface BundleComponent {
  componentVariantId: number;
  quantity: number;
  unitPrice: number;
}

export interface BundleComponentView extends BundleComponent {
  productId: number;
  productName: NameEntity;
  sku: string;
  hasCustomUnitPrice: boolean;
}

export interface ProductEntity {
  isPreOrder?: boolean;
  preOrderAvailableOn?: string | null;
  name: NameEntity;
  images: OrderedProductImage[];
  externalVideos: OrderedProductVideo[];
  primaryCategory?: Category;
  categories: Category[];
  description?: NameEntity;
  type: number;
  brand?: { id: number };
  model?: string;
  limitedToOnePurchases: boolean;
  slug: string;
  relatedProducts: RelatedProduct[];
  status: number;
  variants: VariantEntity[];
  vendorId: number;
  isFeatured: boolean;
  keepTop: boolean;
  attributes: ProductAttributeDetail[];
  shareLink?: string;
  approvalStatus?: number;
  bundleStockMode?: BundleStockMode | null;
  bundleComponents?: BundleComponentView[] | null;
}

export interface ProductDropdownItem {
  id: number;
  name: {
    english: string;
    arabic?: string;
  };
  productFirstImage?: {
    url: string;
    path: string;
  };
  label?: string; // For ng-select compatibility - added dynamically
}
